import { bindable, containerless } from 'aurelia-framework';

@containerless()
export class YesNoSelect {
  @bindable label = '';
  @bindable yes = false;
  @bindable locked = false;
}
